import { render } from "./ButtonShow.vue?vue&type=template&id=7c1011c7"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__